import { Routes, Route } from "react-router-dom"
import { Config } from "../../../biz/data/Config"
import { Account, Accounts, Subscription } from "../Pro/Accounts/Accounts"
import { Tests } from "../Pro/Tests"
import { Home } from "../Pro/Home"
import { SimpleHome } from "../Simple/SimpleHome"
import { SimpleProfile } from "../Simple/SimpleProfile"
import { SimpleAds } from "../Simple/SimpleAds"
import { SimpleCampaigns } from "../Simple/SimpleCampaigns"
import { SimpleAssortments } from "../Simple/SimpleAssortments"
import { SimpleInsights } from "../Simple/SimpleInsights"
import { SimpleBilling } from "../Simple/SimpleBilling"
import { PlantSearch } from "../Simple/PlantSearch"
import { SimpleAppTools } from "../Simple/SimpleAppTools"

export const RouteMapping = () => {
    return (
        <Routes>
            {/* Simple */}
            <Route path={Config.routes.start} element={<SimpleHome />} />
            <Route path={Config.routes.simple_profile} element={<SimpleProfile />} />

            <Route path={Config.routes.simple_ads} element={<SimpleAds />} />

            <Route path={Config.routes.simple_ads_plant} element={<PlantSearch path={Config.routes.simple_ads_plant} />} />
            <Route path={Config.routes.simple_assortment_edit} element={<PlantSearch path={Config.routes.simple_assortment_edit} />} />

            <Route path={Config.routes.simple_campaigns} element={<SimpleCampaigns />} />
            <Route path={Config.routes.simple_assortment} element={<SimpleAssortments />} />
            <Route path={Config.routes.simple_insights} element={<SimpleInsights />} />
            <Route path={Config.routes.simple_billing} element={<SimpleBilling />} />

            <Route path={Config.routes.simple_app_tools} element={<SimpleAppTools />} />

            {/* Pro */}
            <Route path={Config.routes.pro_tests} element={<Tests />} />
            <Route path={Config.routes.pro_home} element={<Home />} />
            <Route path={Config.routes.pro_accounts} element={<Accounts />} />
            <Route path={Config.routes.pro_account} element={<Account />} />
            {/* <Route path="*" element={<Navigate replace to="/404" />} /> */}
        </Routes>
    )
}